import {HeroLayoutTypeEnum, SectionTypesEnum} from "@/scripts/common/enums.js";

export default {
    selectedSection(state) {
        return state.selectedSection;
    },
    selectedSectionIsCaseStudyHero(state, getters) {
        return getters.selectedSection?.type === SectionTypesEnum.MAIN_HEADER;
    },
    selectedSectionIsPortfolioHero(state, getters) {
        const selected = getters.selectedSection;
        const portfolioHeroId = state.portfolio?.portfolioHero?._id;
        return selected?.type === SectionTypesEnum.HERO
            || (!!portfolioHeroId && selected?._id === portfolioHeroId);
    },
    selectedSectionIsLegacyPortfolioHero(state, getters) {
        if (getters.selectedSectionIsPortfolioHero) return false;
        const type = getters.selectedSection?.type;
        return typeof type === 'undefined' || type === null;
    },
    heroIsSidebar(state) {
        return state.portfolio?.portfolioHero?.layoutSettings?.layoutType === HeroLayoutTypeEnum.SIDEBAR;
    },
}